import { AvatarEditorFlow } from '../../avatar-editor/ui';

type RegistrationPhotoReviewScreenProps = {
  initialPhoto: File;
  onContinue: () => void;
};

export function RegistrationPhotoReviewScreen({
  initialPhoto,
  onContinue,
}: RegistrationPhotoReviewScreenProps) {
  return (
    <AvatarEditorFlow
      initialPhoto={initialPhoto}
      onComplete={onContinue}
      variant="registration"
    />
  );
}
